import type { I18n } from '@lingui/core';
import { msg } from '@lingui/core/macro';

import { SERVICE_TYPE_CHOICES } from '@rover/constants/src/translations/service.constants';
import Boarding from '@rover/icons/svg/boarding.svg';
import Daycare from '@rover/icons/svg/daycare.svg';
import DogTraining from '@rover/icons/svg/dog-training.svg';
import DropIn from '@rover/icons/svg/drop-in.svg';
import Grooming from '@rover/icons/svg/grooming.svg';
import Sitting from '@rover/icons/svg/sitting.svg';
import Walking from '@rover/icons/svg/walking.svg';
import type { ServiceTypeOption } from '@rover/types/src/ServiceType';

export const SERVICE_SELECTION_OPTIONS = (i18n: I18n): ServiceTypeOption[] => [
  {
    title: i18n._(msg`Boarding`),
    subtitle: i18n._(msg`in the sitter's home`),
    icon: Boarding,
    value: SERVICE_TYPE_CHOICES.boarding,
  },
  {
    title: i18n._(msg`House Sitting`),
    subtitle: i18n._(msg`in your home`),
    icon: Sitting,
    value: SERVICE_TYPE_CHOICES.traveling,
  },
  {
    title: i18n._(msg`Drop-In Visits`),
    subtitle: i18n._(msg`visits in your home`),
    icon: DropIn,
    value: SERVICE_TYPE_CHOICES.dropIn,
  },
  {
    title: i18n._(msg`Doggy Day Care`),
    subtitle: i18n._(msg`in the sitter's home`),
    icon: Daycare,
    value: SERVICE_TYPE_CHOICES.dayCare,
  },
  {
    title: i18n._(msg`Dog Walking`),
    subtitle: i18n._(msg`in your neighborhood`),
    icon: Walking,
    value: SERVICE_TYPE_CHOICES.walking,
  },
  {
    title: i18n._(msg`Dog Training`),
    // DEV-104195 TODO: translate
    subtitle: 'with a private trainer',
    value: SERVICE_TYPE_CHOICES.training,
    icon: DogTraining,
  },
  {
    title: i18n._(msg`Grooming`),
    subtitle: 'at your home or a groomer’s home',
    value: SERVICE_TYPE_CHOICES.grooming,
    icon: Grooming,
  },
];
